import { render, staticRenderFns } from "./FinalizeOccurrenceModal.vue?vue&type=template&id=5bff6868&scoped=true&"
import script from "./FinalizeOccurrenceModal.vue?vue&type=script&lang=js&"
export * from "./FinalizeOccurrenceModal.vue?vue&type=script&lang=js&"
import style0 from "./FinalizeOccurrenceModal.vue?vue&type=style&index=0&id=5bff6868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bff6868",
  null
  
)

export default component.exports